module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Thin.eot
// module id = 259
// module chunks = 0